/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useContext } from "react";
import { Pet } from "../types/PetTypes";
import { logger } from "@/utils/logger";

// Define the context type
export interface PetContextType {
  pets: Pet[];
  setPets: React.Dispatch<React.SetStateAction<Pet[]>>;
  addPet: (pet: Omit<Pet, "id">) => Pet | null | Promise<Pet | null>;
  updatePet: (id: string, updates: Partial<Pet>) => void | Promise<void>;
  deletePet: (id: string) => void | Promise<void>;
  togglePetActive: (id: string, isActive: boolean) => void | Promise<void>;
  activePet: Pet | undefined;
  setActivePet: React.Dispatch<React.SetStateAction<Pet | undefined>>;
  getPetById: (id: string) => Pet | undefined;
  isLoading: boolean;
}

// Create the context
const PetContext = createContext<PetContextType | undefined>(undefined);

// Custom hook to use the PetContext
export const usePetContext = () => {
  const context = useContext(PetContext);
  if (!context) {
    logger.error("❌ PetContext missing. Caller stack:", new Error().stack);
    logger.error("❌ Current location:", window.location.pathname);
    logger.error(
      "❌ PetProvider should wrap all components using usePetContext",
    );
    throw new Error("usePetContext must be used within a PetProvider");
  }
  return context;
};

export default PetContext;
